import React from "react";
import { ThreeRow } from "../../core/layouts";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import { Text } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import UploadUserImageContainer from "../UploadUserImageContainer/UploadUserImageContainer";
import ImagePreviewContainer from "../ImagePreviewContainer";
import useResponsive from "../../core/hooks/useResponsive";

const UploadAddUserImageContainerStyle = {
  topSectionStyle: {
    marginTop: variables.marginMediumLarge,
  },
  uploadImageHeading: {
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
    fontWeight: variables.fontWeightNormal,
    fontSize: variables.fontSizeNormal,
  },
  middleSectionStyle: {
    marginTop: variables.marginSmallest,
    background: variables.whiteSmoke,
    border: `1px dashed ${variables.grey4}`,
    padding: `${variables.paddingSmall2} ${variables.paddingMedium}`,
    display: variables.dFlex,
    justifyContent: variables.spaceBetween,
  },
};

export default function UploadAddUserFormImageContainer({
  selectedImage,
  setSelectedImage,
  setImageUrl,
  imageId,
}) {
  const intl = useIntl();
  const responsive = useResponsive();

  const maxSize = 5242880;
  const acceptedFilesTypes = ["jpeg", "png", "jpg"];

  return (
    <ThreeRow
      topSection={
        <Text style={UploadAddUserImageContainerStyle.uploadImageHeading}>
          {getLocalizedMessage(intl, "addUser.text.profileImage")}
        </Text>
      }
      topSectionStyle={UploadAddUserImageContainerStyle.topSectionStyle}
      middleSection={
        <UploadUserImageContainer
          setSelectedImage={setSelectedImage}
          maxSize={maxSize}
          acceptedFilesTypes={acceptedFilesTypes}
          minSize={0}
          maxFiles={1}
          type={"PROFILE_IMAGE"}
          setImageUrl={setImageUrl}
        />
      }
      middleSectionStyle={{
        ...UploadAddUserImageContainerStyle.middleSectionStyle,
        ...(responsive.isMd && { width: "70%" }),
      }}
      bottomSection={
        imageId && (
          <ImagePreviewContainer
            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
            imageId={imageId}
            setImageUrl={setImageUrl}
          />
        )
      }
    />
  );
}
